import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-mx-auto long-input" }

import { ProjectIdentifierProps } from "@/types";
import {
  orgApiStore,
  orgStore,
  teamApiStore,
  teamStore,
  useVModel,
} from "@/hooks";
import { FlexBox, SelectInput, TextInput } from "@/components/common";


/**
 * Input fields for editing a project.
 */
const __default__ = {
  name: "ProjectIdentifierInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    name: {},
    description: {},
    isUpdate: { type: Boolean },
    dataCyName: { default: "input-project-name" },
    dataCyDescription: { default: "input-project-description" }
  },
  emits: ["update:name", "update:description"],
  setup(__props: any) {

const props = __props;



const nameText = useVModel(props, "name");
const descriptionText = useVModel(props, "description");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!props.isUpdate)
      ? (_openBlock(), _createBlock(_unref(FlexBox), {
          key: 0,
          b: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SelectInput), {
              modelValue: _unref(orgApiStore).currentOrg,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(orgApiStore).currentOrg) = $event)),
              label: "Organization",
              options: _unref(orgStore).allOrgs,
              class: "q-mr-sm",
              "option-label": "name"
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_unref(SelectInput), {
              modelValue: _unref(teamApiStore).currentTeam,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(teamApiStore).currentTeam) = $event)),
              label: "Team",
              options: _unref(teamStore).teamsWithCreateProject,
              class: "full-width",
              "option-label": "name"
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(TextInput), {
      modelValue: _unref(nameText),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(nameText) ? (nameText).value = $event : null)),
      label: "Project Name",
      hint: "Required",
      "data-cy": props.dataCyName
    }, null, 8, ["modelValue", "data-cy"]),
    _createVNode(_unref(TextInput), {
      modelValue: _unref(descriptionText),
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(descriptionText) ? (descriptionText).value = $event : null)),
      type: "textarea",
      label: "Project Description",
      "data-cy": props.dataCyDescription
    }, null, 8, ["modelValue", "data-cy"])
  ]))
}
}

})